"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import makeStyles from "../../theming/make-styles.js";
import Checkbox from "../checkbox/index.js";
import getColorComponent from "../utils/get-color-component.js";
import makePadding from "../utils/make-padding.js";
import { TableContext } from "./table.js";
const paddings = {
    small: { x: "md", y: "sm" },
    medium: { x: "md", y: 12 },
    large: { x: "md", y: "md" },
};
const useStyles = makeStyles()((theme, { color, size }) => {
    const palette = theme.palette(color).table;
    const padding = makePadding(paddings, theme);
    return {
        wrapper: {
            position: "sticky",
            left: theme.spacing(48),
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            maxWidth: "100%",
            width: "100%",
            minHeight: theme.size(21),
            backgroundColor: palette.headOverlay.backgroundColor,
        },
        checkbox: {
            width: theme.size(16),
            minWidth: "min-content",
            padding: padding(size, "0"),
            fontSize: theme.typography.small.fontSize,
        },
        container: {
            flexGrow: 1,
            padding: padding(size, "0"),
            paddingTop: 0,
            paddingBottom: 0,
            fontSize: theme.typography.small.fontSize,
            fontWeight: theme.typography.fontWeights.bold,
        },
    };
});
export const TableHeadOverlay = React.forwardRef(function TableHeadOverlay(_a, ref) {
    var { actions, allSelected = false, children, className, color = "primary", hidden: _ = false, indeterminate = false, selectable: selectableCheckbox, onSelect } = _a, props = __rest(_a, ["actions", "allSelected", "children", "className", "color", "hidden", "indeterminate", "selectable", "onSelect"]);
    const { selectable, size } = useContext(TableContext);
    const { classes, cx } = useStyles({ color, size });
    return (_jsxs("div", Object.assign({ ref: ref, className: cx(classes.wrapper, className) }, props, { children: [(selectable || selectableCheckbox) && (_jsx("div", { className: classes.checkbox, children: _jsx(Checkbox, { color: getColorComponent(color), indeterminate: indeterminate, value: allSelected, onChange: onSelect }) })), _jsxs("div", { className: classes.container, children: [children, actions] })] })));
});
export default TableHeadOverlay;
//# sourceMappingURL=table-head-overlay.js.map